import { render, staticRenderFns } from "./list-view.vue?vue&type=template&id=b7f16bd8&scoped=true"
import script from "./list-view.vue?vue&type=script&lang=js"
export * from "./list-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f16bd8",
  null
  
)

export default component.exports